import { getShownFieldsInitial, LIST_VIEW_MOBILE_WIDTH } from '../constants';
import { IListViewBoard } from './listViewBoard/types';

export const getListViewBoardInitialState =
(): IListViewBoard => {
    const listViewBoardInitialState: IListViewBoard = {
        collapsedGroups: [],
        isBlocked: false,
        isCollapsed: false,
        isGroupByEpics: true,
        // @ts-ignore
        isMobile: window._innerWidth < LIST_VIEW_MOBILE_WIDTH,
        orderType: null,
        printMode: false,
        shownFields: getShownFieldsInitial(),
    };
    return listViewBoardInitialState;
};
